import { observable, makeObservable, action, runInAction } from 'mobx';
import { api } from '../../constants/apis';
import { deleteRequest, get, post, put } from '../../utils/axios-requests';

export default class ViewCardUiStore {
  @observable error: string = '';
  @observable context: any = null;
  @observable loading: boolean = false;
  @observable card: any = null;
  @observable query: string = '';
  @observable languages: Array<any> = [];
  @observable cards: Array<any> = [];
  @observable information: Array<any> | undefined = [];
  @observable userCards: Array<any> = [];
  @observable connectionOrign: Array<string> = [];
  @observable connection: Array<string> = [];
  @observable settings: any = null;
  @observable tags: Array<string> = [];

  constructor() {
    makeObservable(this);
  }

  @action
  public initliazeContext = (context: any) => {
    this.context = context;
  };

  @action
  public setError = (err: string) => {
    this.error = err;
  };

  @action
  public fetchCard = async (cardId: string, all: string) => {
    try {
      if (this.context.authenticatedUser.id) {
        const res = await get(all ? api.cards.allCards : api.cards.card, {
          userId: this.context.authenticatedUser.id,
          cardId,
        });

        runInAction(() => {
          this.languages = res.data.languages;
          this.card = res.data.card;
          this.card.connections = res.data.connections;
          this.information = res.data.information;
          if (res.data.connected) {
            this.getConnection(cardId);
          }
        });

        const res2 = await get(api.users.settings);
        this.settings = res2.data;

        return res.data;
      } else {
        const res = await get(api.cards.public, {
          userId: this.context.authenticatedUser.id,
          cardId,
        });
        runInAction(() => {
          this.languages = res.data.languages;
          this.card = res.data.card;
          this.card.connections = res.data.connections;
          this.information = res.data.information;
        });
        return res.data;
      }
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public getConnection = async (cardId: string) => {
    try {
      if (cardId) {
        const res = await get(api.connections.card, { cardId });

        runInAction(() => {
          this.connection = res.data;
          this.connectionOrign = res.data;
        });
      }
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public updateConnection = async () => {
    try {
      await put(
        api.connections.card,
        {
          cardIds: this.connection,
          initCards: this.connectionOrign,
        },
        { cardId: this.card._id }
      );
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  public fetchCards = async (cardId: string) => {
    try {
      const res2 = await get(api.cards.user);

      runInAction(() => {
        this.userCards = res2.data;
      });

      const res = await get(api.connections.alias, {
        userId: this.context.authenticatedUser.id,
        cardId,
      });

      runInAction(() => {
        this.cards = res.data;
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public getUserTags = async () => {
    try {
      const res = await get(api.connections.tags);

      runInAction(() => {
        this.tags = res.data;
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public resetCard = async () => {
    this.languages = [];
    this.card = {};
    this.card.connections = 0;
    this.information = undefined;
    this.card = null;
  };

  @action
  public deleteCard = async (cardId: string) => {
    try {
      await deleteRequest(api.cards.card, {
        cardId,
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public cancelRequest = async (cardId: string) => {
    try {
      await deleteRequest(api.connections.cancelRequest, {
        cardId,
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public getAvailability = async (id: string) => {
    try {
      const res = await get(api.availability.single, { id });
      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public fetchAddressInfo = async (infoId: string) => {
    try {
      const res = await get(api.informationList.address, {
        infoId,
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public sendSyncRequest = async (
    cards: Array<string>,
    message: string,
    cardId: string
  ) => {
    try {
      const res = await post(api.connections.requests, {
        cardRequested: cardId,
        cards,
        message,
      });

      return res.data;
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public updateFollow = async (follow: boolean, cardId: string) => {
    try {
      if (follow)
        await post(api.connections.follow, {
          cardRequested: cardId,
        });
      else
        await deleteRequest(api.connections.unfollow, {
          cardId,
        });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public unsync = async (cardId: string) => {
    try {
      await deleteRequest(api.connections.unsync, {
        cardId,
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public addCardToConnections = async (cardId: string) => {
    try {
      if (this.connection.includes(cardId)) {
        this.connection = this.connection.filter((i) => i !== cardId);
      } else {
        this.connection.push(cardId);
      }
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  public removeCard = async (cardId: string) => {
    try {
      await deleteRequest(api.connections.card, { cardId });
      runInAction(() => {
        this.cards = this.cards.filter((i: any) => i._id !== cardId);
      });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  public setDefaultCard = async (cardId: string) => {
    try {
      await post(api.connections.default, {}, { cardId });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  public getLabelAndDefaultCard = async (cardId: string) => {
    try {
      const res = await get(api.connections.label, {
        userId: this.context.authenticatedUser.id,
        cardId,
      });

      const res2 = await get(api.connections.default, {
        userId: this.context.authenticatedUser.id,
        cardId,
      });

      return { label: res.data, card: res2.data };
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  public updateLabel = async (cardId: string, label: string, img: string) => {
    try {
      await put(api.connections.label, { label, img }, { cardId });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public toggleFavirote = async (favorite: boolean, cardId: string) => {
    try {
      await post(api.connections.favorite, { favorite }, { cardId });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };

  @action
  public updateConnectionTags = async (tags: Array<string>, cardId: string) => {
    try {
      this.tags = this.tags.concat(tags.filter((i) => !this.tags.includes(i)));
      await put(api.connections.connectionTags, { tags }, { cardId });
    } catch (error: any) {
      if (error.response) {
        this.setError(error.response.data);
      } else {
        this.setError(
          "Error: Can't complete this process right now. Please try again later"
        );
      }

      return false;
    }
  };
}
